import * as Yup from 'yup';

export const ConsultaSchema = Yup.object().shape({
  tipoBusca: Yup.string()
    .nullable()
    .required('Campo requerido.'),
  uf: Yup.string()
    .nullable()
    .required('Campo requerido.'),
});
